// components
import { useEffect, useState } from "react";
import { Head } from "./components/head/head";
import { Container } from "react-bootstrap";
import Counter from "./components/counter/counter";
import { ThemeData } from "./contexts/themeContext/themeContext";
import { Text } from "./contexts/textContext/textContext";
import LetterCounts from "./components/letterCounts/letterCounts";
import Footer from "./components/footer/footer";

export default function App() {

  const [themeMode, setThemeMode] = useState('dark');
  const [text, SetText] = useState('');

  // setting theme via themeMode State
  useEffect(() => {
    document.body.setAttribute('data-bs-theme', themeMode);
  }, [themeMode])

  return (
    <ThemeData.Provider value={themeMode}>
      <Container>
        <Text.Provider value={text}>
          <Head themeMode={themeMode} setThemeMode={setThemeMode} SetText={SetText} />
          <Counter />
          <LetterCounts />
        </Text.Provider>
      </Container>
      <Footer />
    </ThemeData.Provider>
  )
}